// extracted by mini-css-extract-plugin
export default {"modalOverlay":"TR-z","modalContent":"UR-z","header":"VR-z","close":"WR-z"};